import { combineReducers } from "@reduxjs/toolkit";

import {
	archivesBankTransactionsDataState,
	archivesBankTransactionsDataReducer,
	archivesBankTransactionsDataAction,
} from "./data";
import {
	archivesBankTransactionsFilterState,
	archivesBankTransactionsFilterReducer,
	archivesBankTransactionsFilterAction,
} from "./filter";

export type StateBankTransactions = {
	data: archivesBankTransactionsDataState;
	filter: archivesBankTransactionsFilterState;
};

export const bankTransactions = combineReducers<StateBankTransactions>({
	data: archivesBankTransactionsDataReducer,
	filter: archivesBankTransactionsFilterReducer,
});

export const archivesBankTransactionsAction = {
	data: archivesBankTransactionsDataAction,
	filter: archivesBankTransactionsFilterAction,
};

export default bankTransactions;
